import(/* webpackMode: "eager" */ "/srv/gentletales/next-app/app/not-found.tsx");
